const DEFAULT_MASTER_API_PATH = '/api/v1';
const DEFAULT_MASTER_HOST = 'http://localhost:3001';

const getWindow = () => (typeof window !== 'undefined' ? window : undefined);

const resolveClientUrl = () => {
  const envUrl = process.env.REACT_APP_CLIENT_URL;
  if (envUrl && envUrl.trim()) {
    return envUrl.trim();
  }
  const win = getWindow();
  if (win && win.location && win.location.origin) {
    return win.location.origin;
  }
  return DEFAULT_MASTER_HOST;
};

const resolveMasterApiUrl = () => {
  const win = getWindow();
  const envUrl = process.env.REACT_APP_CLIENT_MASTER_API_URL;
  let baseCandidate;

  if (envUrl && envUrl.trim()) {
    baseCandidate = envUrl.trim();
  } else {
    const isLocalHost = (win && win.location && win.location.hostname === 'localhost');
    const fallbackBase = isLocalHost ? DEFAULT_MASTER_HOST : resolveClientUrl();
    baseCandidate = `${fallbackBase.replace(/\/$/, '')}${DEFAULT_MASTER_API_PATH}`;
  }

  try {
    const parsed = new URL(baseCandidate, DEFAULT_MASTER_HOST);
    if (win && win.location && win.location.protocol === 'https:' && parsed.protocol === 'http:') {
      parsed.protocol = 'https:';
    }
    return parsed.toString().replace(/\/$/, '');
  } catch (_) {
    return `${DEFAULT_MASTER_HOST}${DEFAULT_MASTER_API_PATH}`;
  }
};

const apiBaseUrl = resolveMasterApiUrl();

export const getApiBaseUrl = () => apiBaseUrl;
export default apiBaseUrl;